import React, {useCallback} from "react";
import SwivuModal from "../../../react/components/editors/SwivuModal.jsx";
import {WIDGET_KEYS} from "../../../other/constants/WidgetKeys.jsx";
import UserContactTab from "./UserContactTab.jsx";
import UserGeneralTab from "./UserGeneralTab.jsx";
import {PERSISTENCE_STATE_KEYS} from "../../../other/constants/PersistenceStateKeys.jsx";
import MainEditorBase from "../base/MainEditorBase.jsx";

// Todo: it should have permissions
class SwivuUserEditor extends MainEditorBase {
  static get $name() {
    return "SwivuUserEditor";
  }

  static get type() {
    return WIDGET_KEYS.swivuUserPopup;
  }

  static get configurable() {
    return {
      ...super.configurable,
      title: "New User",
      minWidth: "30em",
      maxWidth: "100vw",
      width: "60em",
      closable: true,
      autoClose: false,
      draggable: true,
      cls: "resize",
      modal: true,
      stateId: PERSISTENCE_STATE_KEYS.userEditor,
      minHeight: "600px",
      maxHeight: "100vh",
      height: "min(100vh, 800px)",
      autoUpdateRecord: true,
      defaults: {
        labelWidth: "6em",
      },
      header:{
        cls: 'h-[50px]',
      },
      listeners: {
        hide: "swivuCallOnHideOnTabItems"
      },
      items: {
        tabs: {
          type: WIDGET_KEYS.swivuTabPanel,
          cls: "h-full",
          stateId: "swivu-user-editor",
          items: {
            generalTab: { type: UserGeneralTab.type },
            contactTab: { type: UserContactTab.type, swivuDisableOnPhantomRecord: true, },
          }
        }
      },
      tools: {
        swivuAssistButton: {
          type: "button",
          icon: "fa-regular fa-question",
          cls: "swivu-assist-button b-transparent b-tool",
          listeners: {
            click: "up.onSwivuAssistButtonClick"
          }
        }
      }
    }
  }

  editRecord(record, context, otherParams) {
    super.editRecord(record, context, otherParams);
    this.title = record?.name || "New User";

    this.configureEditorContextMenu(record, context, {
      recordStore: context.project.boardUsersStore,
    });

    this.eachWidget((w) => {
      if (w.isUserEditorBase) {
        w.editRecord(record, context, { ...otherParams, editor: this });
      }
    });
  }

  swivuCallOnHideOnTabItems() {
    this.destroyTabCheckListener();
  }
}

SwivuUserEditor.initClass();

const SwivuUserEditorPopup = ({ context, record, onClose, isShow, editorInstance }) => {
  const { user, selectTabByTypeOnOpen } = record || {};
  const onShowHandler = useCallback((editor, otherParams = {}) => {
    editor.project = context.project;
    editor.editRecord(user, context, Object.assign(otherParams, { selectTabByTypeOnOpen }));
    editorInstance.editorRef = editor;
  }, [context, editorInstance, record]);

  return (
    <SwivuModal
      widgetType={WIDGET_KEYS.swivuUserPopup}
      isShow={isShow}
      onHide={onClose}
      onShow={onShowHandler}
    />
  )
}

export default SwivuUserEditorPopup;